import AuthMiddleware from "@/middleware/auth";

export default [
  {
    path: "/player",
    name: "config.player",
    component: () => import(/* webpackChunkName: "feed" */ "../views/Player.vue"),
    meta: {
      middleware: [AuthMiddleware],
      title: "Empresas",
      layout: "config",
      guards: ["acl", "feature"],
      slug: "config.view",
      featureSlug: "players",
    },
  },
  {
      path: "/player-groups",
      name: "config.player.groups",
      component: () => import(/* webpackChunkName: "feed" */ "@/modules/config/views/PlayerGroups.vue"),
      meta: {
        middleware: [AuthMiddleware],
        title: "Grupos de empresas",
        layout: "config",
        guards: ["acl", "feature"],
        slug: "config.view",
        featureSlug: "players",
      },
    },
];
